import { render, staticRenderFns } from "./PostInscription.vue?vue&type=template&id=37ea05e2&scoped=true"
import script from "./PostInscription.vue?vue&type=script&lang=ts"
export * from "./PostInscription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea05e2",
  null
  
)

export default component.exports